import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-choose-mode',
  templateUrl: './choose-mode.component.html',
  styleUrls: ['./choose-mode.component.css']
})
export class ChooseModeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
